import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import Drivers from "@/pages/Drivers";
import EmployeeDetail from "@/pages/EmployeeDetail";
import Assignments from "@/pages/Assignments";
import Contraventions from "@/pages/Contraventions";
import Contracts from "@/pages/Contracts";
import Insurances from "@/pages/Insurances";
import Maintenance from "@/pages/Maintenance";
import Accidents from "@/pages/Accidents";
import Fuel from "@/pages/Fuel";
import Expenses from "@/pages/Expenses";
import Deadlines from "@/pages/Deadlines";
import Documents from "@/pages/Documents";
import Reports from "@/pages/Reports";
import Convertisseur from "@/pages/Convertisseur";
import Admin from "@/pages/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/vehicles/:id" element={<VehicleDetail />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/drivers/:id" element={<EmployeeDetail />} />
            <Route path="/assignments" element={<Assignments />} />
            <Route path="/contracts" element={<Contracts />} />
            <Route path="/contraventions" element={<Contraventions />} />
            <Route path="/insurances" element={<Insurances />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/accidents" element={<Accidents />} />
            <Route path="/fuel" element={<Fuel />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/deadlines" element={<Deadlines />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/convertisseur" element={<ProtectedRoute roles={["admin", "fleet_manager"]}><Convertisseur /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
